<template>
<div class="goods">
    <v-head :title="title"></v-head>
    <div class="banner"><h3>我要投票</h3></div>
    <div class="contBox">
    <div class="title">
      <h4>第一届茶会ACGN轮换投票活动-第一回漫画周</h4>
      <p>投票时间：2020-01-12至2020-02-01</p>
      <p>选举投票 发起人：管理员</p>
    </div>
    <div  class="content m-content overflow-line" id="J_description">
       第一届ACGN轮换投票活动-第一回漫画周 活动时间：2020年2月10日（周一）-2020年2月15日（周六） 2月10日群内将发起海选投票链接，周三下午19：30投票截止并统计结果，进入前7名的作品将进入之后的决赛，随后会在群内发布决赛作品投票，请群友们投出登记作品内自己最爱的漫画作品。 每周日将发布下周的参赛作品名单，范围为1月1日到2月9日之前的新漫画和正在连载的漫画（因为漫画作品数量庞大，请在周日我睡觉之前找我登记作品，希望你们推荐的作品都是精品中的精品！），希望群友们积极参与投票~ 奖励 冠军：由画师井上樱为冠军作品绘制的画作一副（一周内完成，完成度为黑白线稿），修改群头像为冠军作品相关，并给予所有冠军群友奖章一枚，拥有冠军奖章的群友如果下次再次获得冠军，可以要求画师井上樱升级本次与上次夺冠获得的奖励画作。 亚军：没有奖励。 季军：没有奖励。 此外，每周日的中午11：00~11：30与晚上19:00~19:30将进行冠军作品的安利与讨论（届时将禁止群内其他讨论），欢迎冠军投票者和其他群友积极参加。 我们会记录每周的冠军，冠军奖章可以在年末时换取神秘礼品哦。 本活动最终解释权归井上樱所有。
    </div>
    <van-divider>投票选项</van-divider>
    <p class="zsFont"><i class="red">说明：此次选举为无记名投票，每人最少限投1人，最多限投2人</i></p>
    <van-radio-group v-model="radio">
        <van-cell-group>
            <van-cell title="单选框 1" clickable @click="radio = '1'">
            <van-radio slot="right-icon" name="1" />
            </van-cell>
            <van-cell title="单选框 2" clickable @click="radio = '2'">
            <van-radio slot="right-icon" name="2" />
            </van-cell>
        </van-cell-group>
    </van-radio-group>
    <div class="vanButon"><van-button type="primary" block>提交</van-button></div>
    </div>
</div>
</template>

<script type="text/javascript">
import {

} from "@/api/dictionary";
import vHead from "../../../components/meuSubHeader.vue";
import {NavBar,Button,Icon,RadioGroup, Radio, Cell, CellGroup,Divider  } from 'vant';
export default {
  data() {
    return {
        title:"投票选举",
        radio: '',
    };
  },
  components: {
    vHead,
    [NavBar.name]:NavBar,
    [Button.name]:Button,
    [Icon.name]:Icon,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup,
    [Divider.name]:Divider,
  },
  methods: {
    onConfirm(date) {
      this.showa = false;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  mounted() {
    
  }
};
</script>

<style lang="less" scoped>
.van-nav-bar{border-bottom:none; height: 55px; line-height: 55px; position: fixed; top:0; width:100%;}
.banner{ margin-top:55px; background-image: linear-gradient(90deg, #9c4dff 0%, #42a7ff 100%);
  display: flex;align-items: center; height: 100px;}
.banner h3{ text-align: center; color: #fff;font-size: 20px; width: 100%;}
.contBox{ padding:0 20px; margin-top: 30px;}
.title h4{ font-size:18px;  line-height: 28px; margin:0 auto; font-weight: bold; margin-bottom: 10px;}
.title p{ font-size:13px;  line-height: 22px;}
.content{ font-size:14px; margin-top: 20px; line-height: 24px;}
.zsFont{ width: 90%; margin:0 auto; margin-bottom: 20px;}
.red{ font-size:13px; color: red;}
.vanButon{ width: 90%; margin:30px auto;}
</style>